import { css } from 'emotion';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { injectGlobal } from 'react-emotion';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import EmptyManageEvents from './EmptyManageEvents/EmptyManageEvents';
import ManageEventsBodyForm from './ManageEventsBodyForm/ManageEventsBodyForm';
import Spinner from '../../../components/Spinner/Spinner';

const enterDuration = 250;
const exitDuration = 0;
const exitToEnterGapDuration = 250;

injectGlobal`
  .fade-enter {
    opacity: 0.01;
  }
  
  .fade-enter-active {
    opacity: 1;
    transition: opacity ${enterDuration}ms linear;
  }
  
  .fade-exit {
    opacity: 1;
  }
  
  .fade-exit-active {
    opacity: 0.01;
    transition: opacity ${exitDuration}ms linear;
  }
`;

const FormContainer = styled('div')`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  position: relative;
  width: 100%;
`;

const SpinnerContainer = styled('div')`
  display: flex;
  justify-content: center;
  margin-top: 15rem;
  width: 100%;
`;

class ManageEventsBody extends React.Component {
  state = {
    isVisible: true,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.activeEvent.id !== this.props.activeEvent.id) {
      this.setState({
        isVisible: false
      });
      setTimeout(() => {
        this.setState({
          isVisible: true
        });
      }, exitToEnterGapDuration);
    }
  }

  render() {
    if (!this.props.isRequesting) {
      if (this.props.isEmpty) {
        return (
          <FormContainer>
            <EmptyManageEvents />
          </FormContainer>
        )
      }

      return (
        <FormContainer>
          <TransitionGroup>
            {this.form}
          </TransitionGroup>
        </FormContainer>
      );
    }
    return (
      <SpinnerContainer>
        <Spinner message="Fetching your events..." />
      </SpinnerContainer>
    );
  }

  get form() {
    return this.state.isVisible ? (
      <CSSTransition
        classNames="fade"
        timeout={{
          enter: enterDuration,
          exit: exitDuration,
        }}
      >
        <ManageEventsBodyForm
          eventTitle={this.props.activeEvent.title}
          initialValues={this.props.activeEvent}
        />
      </CSSTransition>
    ) : null;
  }
}

ManageEventsBody.propTypes = {
  activeEvent: PropTypes.object.isRequired,
  isEmpty: PropTypes.bool,
  isRequesting: PropTypes.bool.isRequired,
};

ManageEventsBody.defaultProps = {
  isEmpty: false,
  isRequesting: false,
};

export default ManageEventsBody;



// WEBPACK FOOTER //
// ./src/views/ManageEvents/ManageEventsBody/ManageEventsBody.js